module.exports = __webpack_public_path__ + "img/society-tubman-avatar.fee2ee41.png";